module.exports = __webpack_public_path__ + "static/media/13.189b61c8.png";